import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Select } from '@guildeducationinc/recess';
import { useEffect, useMemo } from 'react';
import { useIntegrationConfigs } from '../../hooks/useIntegrationConfigs';
/**
 * A component that renders a integrationConfig picker.
 */
export const IntegrationConfigPicker = (props) => {
    const { items, loading } = useIntegrationConfigs({
        clientId: props.clientId,
        direction: props.direction,
    });
    function getOptionValue(integrationConfig) {
        if (props.getOptionValue) {
            return props.getOptionValue(integrationConfig);
        }
        return String(integrationConfig.id);
    }
    const options = useMemo(() => {
        return ((items || [])
            .filter(cfg => !props.direction || cfg.direction === props.direction)
            .map(integrationConfig => ({
            value: getOptionValue(integrationConfig),
            label: integrationConfig.name,
        })) ?? []);
    }, [items, props.direction]);
    useEffect(() => {
        if (!loading && props.value && props.onInit) {
            props.onInit(items?.find(x => getOptionValue(x) === props.value));
        }
    }, [loading]);
    /**
     * Handles the change event of the select component.
     * @param event The select change event.
     */
    const handleOnChange = (event) => {
        if (props.onChange) {
            props.onChange(items?.find(x => getOptionValue(x) === event.target.value));
        }
    };
    return (_jsx(_Fragment, { children: !loading && (_jsx(Select, { label: props.label ?? '', placeholder: props.placeholder, onChange: handleOnChange, options: options, className: props.className, value: props.value, errors: props.errors, isSearchable: props.isSearchable ?? true })) }));
};
